export default __webpack_public_path__ + "static/media/Hsu, Yu yun.2a3620ff.webp";